import { z } from 'zod';

export const AppletsScalarFieldEnumSchema = z.enum(['appletId','cityId','appletName','appletType','templateName','appletData','deleted']);

export default AppletsScalarFieldEnumSchema;
